import { render, staticRenderFns } from "./sent-email-sms-page.html?vue&type=template&id=16013564&scoped=true&external"
import script from "./sent-email-sms-page.js?vue&type=script&lang=js&external"
export * from "./sent-email-sms-page.js?vue&type=script&lang=js&external"
import style0 from "./sent-email-sms-page.scss?vue&type=style&index=0&id=16013564&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16013564",
  null
  
)

export default component.exports